(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
      const button = item.querySelector('dt button');
      const indicator = button.querySelector('.indicator');

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        accordionItems.forEach(i => {
          const btn = i.querySelector('dt button');
          const ind = btn.querySelector('.indicator');
          btn.setAttribute('aria-expanded', false);
          i.querySelector('dd').classList.add('h-0', 'opacity-0', 'p-0');
          i.querySelector('dd').classList.remove('h-auto', 'opacity-100', 'p-5');
          indicator.innerHTML = `
			<svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
				<path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6"/>
			</svg>`;
        });

        if (! expanded) {
          button.setAttribute('aria-expanded', true);
          item.querySelector('dd').classList.remove('h-0', 'opacity-0', 'p-0');
          item.querySelector('dd').classList.add('h-auto', 'opacity-100', 'p-5');
          indicator.innerHTML = `
			<svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
				<path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6"/>
			</svg>`;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  if (enable_minmax_buys) {
    // Wait for the function to be available
    if (typeof _checkCartPageQuantities === 'function') {
      _checkCartPageQuantities(mins, maxs);
    } else {
      // Retry after a short delay if function isn't available yet
      setTimeout(() => {
        if (typeof _checkCartPageQuantities === 'function') {
          _checkCartPageQuantities(mins, maxs);
        } else {
          console.warn('_checkCartPageQuantities function not available');
        }
      }, 100);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-cross-sells");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300 && request.response !== "") {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                productRecommendationsSection.innerHTML = container.querySelector(".product-cross-sells").innerHTML;

                if(document.querySelector(".product-cross-sells").textContent.trim() === ""){
                    document.querySelector(".product-cross-sells").closest('section').remove();
                } else {
                    window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
                    window.globalQuickView();
                }

            }else{
                window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-cross-sell") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
	// Look for an element with class 'product-recommendations'
	var productRecommendationsSection = document.querySelector(".product-recommendations");
	
	if (productRecommendationsSection === null) { return; }
	
	
	// Build request URL
	var requestUrl = productRecommendationsSection.dataset.url;
	
	// Create request and submit it using Ajax
	var request = new XMLHttpRequest();
	
	request.open("GET", requestUrl);
	
	request.onload = function() {
		if (request.status >= 200 && request.status < 300) {
			var container = document.createElement("div");
			container.innerHTML = request.response;
			productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
			window.initSlider(document.querySelector('.related-slider'), 1, 'section');
		}
	};
	
	request.send();
};

document.addEventListener("shopify:section:load", function(event) {
	if (event.detail.sectionId === "product-recommendations") {
		loadProductRecommendationsIntoSection();
	}
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    let quotes = document.querySelectorAll('.swiper blockquote p');

    quotes.forEach(quote => {
      let words = quote.textContent.split(' ');
      let maxWords = 60

      if (words.length > maxWords) {
        let displayedText = words.slice(0, maxWords).join(' ');
        let hiddenText = words.slice(maxWords).join(' ');
        let moreLink = document.createElement('a');
        let lessLink = document.createElement('a');

        moreLink.classList.add('text-green-500');
        lessLink.classList.add('text-green-500');

        moreLink.textContent = 'Read More';
        lessLink.textContent = 'Show Less';

        moreLink.href = '#!';
        moreLink.style.display = 'block'; // Changed to block
        lessLink.href = '#!';
        lessLink.style.display = 'none';

        quote.innerHTML = displayedText;
        quote.appendChild(moreLink);

        let fullTextContainer = document.createElement('span'); // Changed to span for inline
        fullTextContainer.innerHTML = hiddenText;
        fullTextContainer.style.display = 'none';
        quote.appendChild(fullTextContainer);
        quote.appendChild(lessLink);

        moreLink.addEventListener('click', function(e) {
          e.preventDefault();
          fullTextContainer.style.display = 'inline'; // Changed to inline
          lessLink.style.display = 'block'; // Changed to block
          moreLink.style.display = 'none';
        });

        lessLink.addEventListener('click', function(e) {
          e.preventDefault();
          fullTextContainer.style.display = 'none';
          lessLink.style.display = 'none';
          moreLink.style.display = 'block'; // Changed to block
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
